// This will load all the user's wallets on the admin page.
import React, { useEffect, useState } from "react";
import LoadingContent from "../../../components/LoadingContent.jsx";
import useCommunityWallets from "../../../functions/Firestore/useCommunityWallets.js";
import useActiveLocations from "../../../functions/Firestore/useActiveLocations.js";

import CommunityMemberSearch from "../Components/CommunityMemberSearch.jsx";
import TransactionHistoryDialog from "../Dialogs/TransactionHistoryDialog.jsx";
import AdjustMemberWallet from "../Dialogs/AdjustMemberWallet.jsx";
import AddFundsToMemberWallet from "../Dialogs/AddFundsToMemberWallet.jsx";
import PaymentInfoDialog from "../Dialogs/PaymentEntry/components/PaymentInfoDialog.jsx";

export default function CommunityWalletsTab() {
  // Load teh wallets.
  const [communityWalletsTemp, walletsLoading, walletsError] =
    useCommunityWallets();
  // Load the locations to list them for where the cash was collected.
  const {
    locations,
    loading: locationsLoading,
    error: locationsError,
  } = useActiveLocations();

  // Combine loading/error states
  const loading = walletsLoading || locationsLoading;

  const error = walletsError || locationsError;

  // Sets the wallet states.
  const [communityWallets, setCommunityWallets] = useState([]);
  // Loads the wallets.
  useEffect(() => {
    if (communityWalletsTemp?.length > 0) {
      const sortedWallets = [...communityWalletsTemp].sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase()),
      );
      setCommunityWallets(sortedWallets);
    }
  }, [communityWalletsTemp]);

  if (loading) {
    return (
      <div>
        <LoadingContent inline={true} />
      </div>
    );
  }
  if (error) {
    return (
      <div>
        <p>Error loading community wallets: {error}</p>
      </div>
    );
  }

  return (
    <div>
      <h2>Community Wallet Transactions</h2>
      <CommunityMemberSearch
        communityWallets={communityWallets}
        setCommunityWallets={setCommunityWallets}
      />
      <PaymentInfoDialog communityWallets={communityWallets} />
      <table border="1">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Amount</th>
            <th>Transaction History</th>
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          {communityWallets.map((wallet, index) => (
            <tr key={index}>
              <td>{wallet.firstName}</td>
              <td>{wallet.lastName}</td>
              <td>${wallet.Total?.toFixed(2) || "0.00"}</td>
              <td>
                <TransactionHistoryDialog
                  buttonSize="small"
                  balance={parseFloat(wallet.Total)}
                  transactionHistory={wallet.transactionHistory || []}
                />
              </td>
              <td>
                <AdjustMemberWallet
                  communityWallets={communityWallets}
                  index={index}
                  setCommunityWallets={setCommunityWallets}
                />
              </td>
              <td>
                <AddFundsToMemberWallet
                  communityWallets={communityWallets}
                  index={index}
                  setCommunityWallets={setCommunityWallets}
                  wallet={wallet}
                  locations={locations}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
